export const initialConnectValue = {
  is_billing: '1',
};
